import React, { Component } from 'react';

import { Row, Col } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';
import LazyLoad from 'react-lazyload';
import {PlusOutlined } from '@ant-design/icons';

// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";
import "../../Statics/HomePage/Gallery.css";

const Gallery = props => {
    
     return props.size === "laptopdesktop" ? (
        <div style={{ backgroundColor: "#ffffff" }}>
          <Center>
               <Margin top={4}>
                    <p className="subTitle"><strong>گالری تصاویر</strong></p>
               </Margin>
          </Center>
          <Center>
               <div className="subTitleHR"></div>
          </Center>
          <Margin top={3}></Margin>
          <Row>
               <Col span={3}></Col>
               <Col span={18}>
                    <Row>
                         <Col span={6}>
                              <figure className="snip1281 blue">
                                   <LazyLoad>
                                        <img src={require("../../Imgs/HomePage/MiniGallery/gallery2.jpg")} alt="" />
                                   </LazyLoad>
                              </figure>
                         </Col>
                         <Col span={6}>
                              <figure className="snip1281 blue">
                                   <LazyLoad>
                                        <img src={require("../../Imgs/HomePage/MiniGallery/gallery6.jpg")} alt="" />
                                   </LazyLoad>
                              </figure>
                         </Col>
                         <Col span={6}>
                              <figure className="snip1281 blue">
                                   <LazyLoad>
                                        <img src={require("../../Imgs/HomePage/MiniGallery/gallery5.jpg")} alt="" />
                                   </LazyLoad>
                              </figure>
                         </Col>
                         <Col span={6}>
                              <figure className="snip1281 blue">
                                   <LazyLoad>
                                        <img src={require("../../Imgs/HomePage/MiniGallery/gallery3.jpg")} alt="" />
                                   </LazyLoad>
                              </figure>
                              <Margin bottom={3}></Margin>
                         </Col>
                    </Row>
                    <Row>
                         <a href="/imagegallery" class="introBtn introBtn-white introBtn-animated" style={{ fontSize: ".8em", fontFamily: "IRANSans" }}><PlusOutlined style={{color:"#fff"}} /> گالری تصاویر</a>
                    </Row>
               </Col>
               <Col span={3}></Col>
          </Row>
       
   </div>
     ) : props.size === "tablet" ? (
            <div>
               <Center>
                    <p className="subTitleTablet"><strong>گالری تصاویر</strong></p>
               </Center>
               <Center>
                    <hr className="subTitleHRTablet" />
               </Center>
               <Margin top={2}></Margin>
               <Center>
                    <figure className="snip1281 blue">
                              <LazyLoad>
                              <img src={require("../../Imgs/HomePage/MiniGallery/gallery3.jpg")} alt="" />
                                   </LazyLoad>
                    </figure>
               </Center>
               <Center>
                    <figure className="snip1281 blue">
                              <LazyLoad>
                         <img src={require("../../Imgs/HomePage/MiniGallery/gallery2.jpg")} alt="" />
                                   </LazyLoad>
                    </figure>
               </Center>
               <Center>
                    <figure className="snip1281 blue">
                              <LazyLoad>
                         <img src={require("../../Imgs/HomePage/MiniGallery/gallery4.jpg")} alt="" />
                                   </LazyLoad>
                    </figure>
               </Center>
               <Center>
                    <figure className="snip1281 blue">
                              <LazyLoad>
                         <img src={require("../../Imgs/HomePage/MiniGallery/gallery1.jpg")} alt="" />
                                   </LazyLoad>
                    </figure>
               </Center>
               <Center>
                         <a href="/imagegallery" class="introBtn introBtn-white introBtn-animated" style={{ fontSize: ".8em", fontFamily: "IRANSans" }}><PlusOutlined style={{color:"#fff"}} /> گالری تصاویر</a>
                    </Center>
            </div>

     ) : (
            <div>
               <Center>
                    <p className="subTitleMobile"><strong>گالری تصاویر</strong></p>
               </Center>
               <Center>
                    <div className="subTitleHRMobile"></div>
               </Center>
               <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                         <Center>
                         <figure className="snip1281 blue">
                                        <LazyLoad>
                              <img src={require("../../Imgs/HomePage/MiniGallery/gallery3.jpg")} alt="" />
                                             </LazyLoad>
                         </figure>
                         </Center>
                    </Col>
                    <Col span={2}></Col>
               </Row>
               <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                         <Center>
                         <figure className="snip1281 blue">
                                        <LazyLoad>
                              <img src={require("../../Imgs/HomePage/MiniGallery/gallery5.jpg")} alt="" />  
                                             </LazyLoad>   
                         </figure>
                         </Center>
                    </Col>
                    <Col span={2}></Col>
               </Row>
               <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                         <Center>
                         <figure className="snip1281 blue">
                                        <LazyLoad>
                              <img src={require("../../Imgs/HomePage/MiniGallery/gallery6.jpg")} alt="" />  
                                             </LazyLoad>   
                         </figure>
                         </Center>
                    </Col>
                    <Col span={2}></Col>
               </Row>
               <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                         <Center>
                         <figure className="snip1281 blue">
                                        <LazyLoad>
                              <img src={require("../../Imgs/HomePage/MiniGallery/gallery2.jpg")} alt="" />
                                             </LazyLoad>
                         </figure>
                         </Center>
                    </Col>
                    <Col span={2}></Col>
               </Row>
               <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                         <a href="/imagegallery" class="introBtn introBtn-white introBtn-animated" style={{ fontSize: ".75em", fontFamily: "IRANSans" }}><PlusOutlined style={{color:"#fff"}} /> گالری تصاویر</a>
                    </Col>
               </Row>
            </div>
          );
};

export default Gallery;
